import {
  RECIPE_VIEW_TYPES,
  VIEW_TYPES,
  type FlowViewType,
  type ViewType,
} from '@shared/types/views';

const VIEW_TYPE_LABELS: Record<ViewType, string> = {
  artifact_document: 'Document',
  score_card: 'Score',
  action_list: 'Actions',
  metric_grid: 'Indicateurs',
  health_gauge: 'Santé',
  entity_summary: 'Fiche',
  data_table: 'Tableau',
  chart: 'Graphique',
  timeline: 'Chronologie',
  fallback_panel: 'Résultat indisponible',
};

export const getViewTypeLabel = (viewType: ViewType): string => (
  VIEW_TYPE_LABELS[viewType] ?? viewType
);

export const isFlowViewType = (value: unknown): value is FlowViewType => (
  typeof value === 'string' && RECIPE_VIEW_TYPES.includes(value as FlowViewType)
);

export const isViewType = (value: unknown): value is ViewType => (
  typeof value === 'string' && VIEW_TYPES.includes(value as ViewType)
);

export const coerceFlowViewType = (
  value: unknown,
  defaultViewType: FlowViewType = 'metric_grid',
): FlowViewType => (
  isFlowViewType(value) ? value : defaultViewType
);

/**
 * Put on a container that is already a surface: a view inside it drops its own
 * border, background and padding, so a result never shows a card in a card.
 */
export const IN_SURFACE_CLASS =
  '[&_[data-view-surface]]:rounded-none [&_[data-view-surface]]:border-0 [&_[data-view-surface]]:bg-transparent [&_[data-view-surface]]:p-0 [&_[data-view-surface]]:lg:p-0';
